import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Redirect({ path, to }) {
  const goTo = useNavigate();

  useEffect(() => {
    goTo(to || path);
  }, []);

  return null;
}
